/**
 * Copyright (c) Amur 2020
 * 
 * React-js-loader by Amur
 * https://github.com/AmurKhoyetsyan/react-js-loader
 * 
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _index = _interopRequireDefault(require("../../Services/index"));

require("./style.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Box1 = function Box1(props) {
  return _react.default.createElement("div", {
    className: "sl-box1"
  }, _react.default.createElement("div", {
    className: "sl-loader",
    style: {
      "--size": _index.default.getZoom(props.size || 100)
    }
  }, _react.default.createElement("div", {
    className: "sl-loader-items"
  }, _react.default.createElement("div", {
    className: "sl-parent-cub"
  }, _react.default.createElement("div", {
    className: "sl-cub",
    style: {
      "--bg": props.bgColor || "#FFFFFF"
    }
  })))), props.title !== undefined ? _react.default.createElement("div", {
    className: "sl-loader-title",
    style: {
      "--cl": props.color || "#FFFFFF"
    }
  }, _react.default.createElement("span", null, props.title)) : null);
};

var _default = Box1;
exports.default = _default;